import image1 from "../../assets/img/products/Forged-Components Products/Forged-Shafts/steel-pipes-put-together.webp";
import image10 from "../../assets/img/products/Machine-Components-Products/PMC/pc-screen-solar-panels-manufacturing-plant-used-study-solar-energy-systems.webp";
import image17 from "../../assets/img/products/FastenersProduct/High Tensile Bolts/high-tensile-bolts.webp";
import image26 from "../../assets/img/products/Sheet-Metal-Parts Products/Sheet Metal Braces/71WFmuxYycL.webp";
import image33 from "../../assets/img/products/Aluminium-extrusion/5osimce.webp";
import image39 from "../../assets/img/products/Surface-treated/6stpmain.webp";
import image44 from "../../assets/img/products/Fabrication/4-ms-machine-frame-fabrication.webp";
import image49 from "../../assets/img/products/Stainless-steel/8osissm.webp";
import image57 from "../../assets/img/products/Lashing-lifting/9fdr.webp";

const categoriesData = [
  {
    id: 1,
    title: "Forged Components",
    thumbnail: image1,
    category: "forged-components",
  },
  {
    id: 2,
    title: "Machined Components",
    thumbnail: image10,
    category: "machined-components",
  },
  { id: 3, title: "Fasteners", thumbnail: image17, category: "fasteners" },
  {
    id: 4,
    title: "Sheet Metal Parts",
    thumbnail: image26,
    category: "sheet-metal-parts",
  },
  {
    id: 5,
    title: "Aluminium Extrusion",
    thumbnail: image33,
    category: "aluminium-extrusion",
  },
  {
    id: 6,
    title: "Surface Treated",
    thumbnail: image39,
    category: "surface-treated",
  },
  { id: 7, title: "Fabrication", thumbnail: image44, category: "fabrication" },
  {
    id: 8,
    title: "Stainless Steel",
    thumbnail: image49,
    category: "stainless-steel",
  },
  {
    id: 9,
    title: "Lashing & Lifting",
    thumbnail: image57,
    category: "lashing-lifting",
  },
];

export default categoriesData;
